import { render } from "./TrainingGeneralInfoComponent.vue?vue&type=template&id=3a6f1447&scoped=true"
import script from "./TrainingGeneralInfoComponent.vue?vue&type=script&lang=js"
export * from "./TrainingGeneralInfoComponent.vue?vue&type=script&lang=js"

import "./TrainingGeneralInfoComponent.vue?vue&type=style&index=0&id=3a6f1447&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6f1447"]])

export default __exports__